import { Component, OnInit, AfterContentInit, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService } from '../../../services';

@Component({
  selector: 'sn-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  @Input() dlgType: string;
  @Input() dlg_config: any;
  @Output() dlg_type_passwords:string = 'abc';

  public prompt_input_text: string;
  public prompt_input_select: string;

  constructor(
    public activeModal: NgbActiveModal,
    public dialogService: DialogService,
  ) { }

	ngOnInit() {
		if (this.dlgType == this.dialogService.dlg_type_loading) {
			if (this.dlg_config && this.dlg_config.timeout > 0) {
				setTimeout(() => {
					this.activeModal.close();
				}, this.dlg_config.timeout);
			}
		}

		if (this.dlg_config && this.dlg_config.input && this.dlg_config.input.type == "L" && this.dlg_config.input.default_value) {
			this.prompt_input_select = this.dlg_config.input.default_value;
		}
	}

	onSubmit(response) {
		this.activeModal.close({ response: response });
	}

	onCancel(response) {
		this.activeModal.dismiss(response);
	}

	onClick(button) {
		if (button) {
			if (button.type == "cancel") {
				this.onCancel(button.event);
			} else {
				var response = { event: button.event, value: this.getPromptInputValue() };
				this.onSubmit(response);
			}
		}
	}

	getPromptInputValue() {
		var value = "";
		switch (this.dlg_config.input.type) {
			case "T": value = this.prompt_input_text; break;
			case "L": value = this.prompt_input_select; break;
		}
		return value;
	}

	isDlgType(type) {
		return this.dlgType == type;
	}

	showTitle(): boolean {
		return this.dlg_config && this.dlg_config.title;
	}

	showClose(): boolean {
		return this.dlg_config && this.dlg_config.showClose == true;
	}

	isEmptyLine(msg) {
		return msg == "" || msg == null || msg == undefined;
	}
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/dialog/dialog.component.ts